module.exports = __webpack_public_path__ + "img/wave.b3ee59dd.svg";